import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import JSZip from 'jszip'
import './assets/tailwind.css'
import { createMetaManager } from 'vue-meta'

// Make JSZip globally available for the imageCompressor utility
window.JSZip = JSZip

const app = createApp(App)
app.use(router)
app.use(createMetaManager())
app.mount('#app') 